import { render } from "./CompareStocks.vue?vue&type=template&id=5d330f79&scoped=true"
import script from "./CompareStocks.vue?vue&type=script&lang=js"
export * from "./CompareStocks.vue?vue&type=script&lang=js"

import "./CompareStocks.vue?vue&type=style&index=0&id=5d330f79&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d330f79"]])

export default __exports__